import { Alert, Portal, Snackbar } from "@mui/material";

export default function SnackbarComponent({ status, onClose, msg, severity, setLoader }) {
  if (!status) return null;
//   setLoader(false);
  return (
    <div>
      <Portal>
        <Snackbar
          className="pt-[5%]"
          open={status}
          autoHideDuration={7000}
          onClose={onClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
            {msg}
          </Alert>
        </Snackbar>
      </Portal>
    </div>
  );
}
